import {API_REVIEW_PERIOD} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const getAll = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_REVIEW_PERIOD,
    });
    return res.data;
  } catch (error) {
    console.error('reviewPeriodApi getAll Error:', error.message);
    return null;
  }
};

const getPeriod = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_REVIEW_PERIOD,
    });
    return res.data
  } catch (error) {
    console.error('reviewPeriodApi getPeriod Error:', error.message);
    return null
  }
}

const reviewPeriodApi = {
  getAll,
  getPeriod
};

export default reviewPeriodApi;
